import React from 'react';

/**
 * Пока открыто окно, страница под ним не прокручивается: иначе колесо
 * уводило ленту за пределы затемнения. Счётчик — окна бывают вложенными.
 * Ширину пропавшей полосы прокрутки возвращаем отступом, чтобы вёрстка
 * не прыгала.
 */
let locks = 0;
let saved: { html: string; body: string; pad: string } | null = null;

export function useScrollLock(enabled = true): void {
  React.useEffect(() => {
    if (!enabled || typeof document === 'undefined') return undefined;
    const html = document.documentElement;
    const body = document.body;
    if (locks++ === 0) {
      const gap = window.innerWidth - html.clientWidth;
      saved = { html: html.style.overflow, body: body.style.overflow, pad: body.style.paddingRight };
      html.style.overflow = 'hidden';
      body.style.overflow = 'hidden';
      if (gap > 0) body.style.paddingRight = `${gap}px`;
    }
    return () => {
      if (--locks === 0 && saved) {
        html.style.overflow = saved.html;
        body.style.overflow = saved.body;
        body.style.paddingRight = saved.pad;
        saved = null;
      }
    };
  }, [enabled]);
}
